export default function BadgeStar({ color, size, earned, icon, name, onClick }) {
  color = color || '#facc15'
  size = size || 60
  earned = earned || false
  icon = icon || '?'
  name = name || '???'

  const c = size / 2
  const outerR = size * 0.45
  const innerR = size * 0.22
  const points = 5
  const rays = []

  for (let i = 0; i < points * 2; i++) {
    const angle = (i * Math.PI) / points - Math.PI / 2
    const r = i % 2 === 0 ? outerR : innerR
    rays.push(`${c + r * Math.cos(angle)},${c + r * Math.sin(angle)}`)
  }

  const starPoints = rays.join(' ')

  const beams = []
  for (let i = 0; i < 10; i++) {
    const angle = (i * Math.PI * 2) / 10 - Math.PI / 2
    const isLong = i % 2 === 0
    const r1 = size * 0.5
    const r2 = isLong ? size * 0.65 : size * 0.56
    beams.push({
      x1: c + r1 * Math.cos(angle),
      y1: c + r1 * Math.sin(angle),
      x2: c + r2 * Math.cos(angle),
      y2: c + r2 * Math.sin(angle),
      isLong
    })
  }

  const displayColor = earned ? color : '#334155'
  const glowColor = earned ? color : 'transparent'

  return (
    <div
      onClick={onClick}
      title={earned ? name : '???'}
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        cursor: onClick ? 'pointer' : 'default',
        gap: '4px'
      }}
    >
      <svg
        width={size * 1.4}
        height={size * 1.4}
        viewBox={`${-size * 0.2} ${-size * 0.2} ${size * 1.4} ${size * 1.4}`}
        style={{
          filter: earned ? `drop-shadow(0 0 8px ${glowColor})` : 'none',
          transition: 'all 0.3s ease'
        }}
      >
        {beams.map((b, i) => (
          <line
            key={i}
            x1={b.x1} y1={b.y1}
            x2={b.x2} y2={b.y2}
            stroke={displayColor}
            strokeWidth={b.isLong ? 2.5 : 1.5}
            strokeLinecap="round"
            opacity={earned ? 0.9 : 0.3}
          />
        ))}

        <polygon
          points={starPoints}
          fill={earned ? `${displayColor}33` : '#1e293b'}
          stroke={displayColor}
          strokeWidth={earned ? 2 : 1}
          opacity={earned ? 1 : 0.4}
        />

        <text
          x={c}
          y={c + (size * 0.13)}
          textAnchor="middle"
          fontSize={earned ? size * 0.3 : size * 0.25}
          opacity={earned ? 1 : 0.4}
        >
          {earned ? icon : '?'}
        </text>
      </svg>

      <div style={{
        fontSize: '0.6rem',
        color: earned ? color : '#475569',
        textAlign: 'center',
        maxWidth: size * 1.4,
        fontWeight: earned ? 'bold' : 'normal',
        lineHeight: 1.2
      }}>
        {earned ? name : '???'}
      </div>
    </div>
  )
}